import { Directive, Input } from '@angular/core';
import { KeyData } from '@zero/shared/util-models';

@Directive()
export class KeyDataBase {
  @Input() public model: KeyData;
}
